import { LegalLayout, H2, P } from "@/components/LegalLayout";

const ROWS = [
  { name: "access_token", purpose: "Mantener la sesión autenticada del usuario tras iniciar sesión.", origin: "Propia (DDP)", duration: "30 minutos", necessary: "Sí" },
  { name: "refresh_token", purpose: "Renovar de forma segura la sesión sin volver a introducir credenciales.", origin: "Propia (DDP)", duration: "7 días", necessary: "Sí" },
  { name: "ddp_redirect", purpose: "Recordar la página solicitada para redirigir tras el inicio de sesión (almacenamiento de sesión del navegador).", origin: "Propia (DDP)", duration: "Duración de la sesión del navegador (se elimina al cerrar la pestaña).", necessary: "Sí" },
];

export default function PoliticaCookies() {
  return (
    <LegalLayout title="Política de cookies" updated="Última actualización: septiembre de 2026">
      <div data-testid="legal-cookies">
        <H2>1. Uso de cookies y almacenamiento en DDP</H2>
        <P>
          DDP utiliza únicamente cookies y mecanismos de almacenamiento <strong>estrictamente necesarios</strong> para el
          funcionamiento del servicio: la autenticación, la seguridad de la sesión y las preferencias imprescindibles para
          operar. <strong>No</strong> se utilizan cookies ni tecnologías de analítica, publicidad, seguimiento o elaboración de
          perfiles.
        </P>
        <P>
          Al tratarse exclusivamente de cookies y almacenamiento técnicos estrictamente necesarios, no se requiere el
          consentimiento previo del usuario y, por ello, DDP no muestra un banner de cookies.
        </P>

        <H2>2. Cookies y almacenamiento utilizados</H2>
        <div style={{ overflowX: "auto" }}>
          <table className="ddp-table" style={{ marginTop: 8 }}>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Finalidad</th>
                <th>Origen</th>
                <th>Duración</th>
                <th>Estrictamente necesaria</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((r) => (
                <tr key={r.name}>
                  <td style={{ fontWeight: 600, whiteSpace: "nowrap" }}>{r.name}</td>
                  <td style={{ color: "#3D3834" }}>{r.purpose}</td>
                  <td style={{ color: "var(--muted)" }}>{r.origin}</td>
                  <td style={{ color: "var(--muted)" }}>{r.duration}</td>
                  <td style={{ color: "var(--muted)" }}>{r.necessary}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <P>
          Las cookies <strong>access_token</strong> y <strong>refresh_token</strong> son cookies técnicas de sesión
          configuradas con atributos de seguridad (HttpOnly, Secure y SameSite) y no son accesibles desde el código de la
          página. <strong>ddp_redirect</strong> es un valor de almacenamiento de sesión del navegador que se elimina al cerrar
          la pestaña.
        </P>

        <H2>3. Gestión de cookies</H2>
        <P>
          Como estas cookies y almacenamiento son necesarios para el funcionamiento del área privada, su bloqueo puede impedir
          el inicio de sesión y el uso del servicio. Puede administrar o eliminar las cookies desde la configuración de su
          navegador; encontrará instrucciones en la ayuda del navegador que utilice.
        </P>

        <H2>4. Cambios en esta política</H2>
        <P>
          Si en el futuro se incorporase alguna cookie o tecnología no estrictamente necesaria, se actualizaría esta política y,
          cuando legalmente proceda, se recabaría el consentimiento correspondiente antes de su uso.
        </P>
      </div>
    </LegalLayout>
  );
}
